// extracted by mini-css-extract-plugin
export default {"containerButtonMenu":"styles_containerButtonMenu__ywSbz","divider":"styles_divider__Pwrob","dividerMobile":"styles_dividerMobile__ghw0Y","subHeader":"styles_subHeader__U6sTO"};